import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '500px',
      gap: '16px',
    },
    title: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '160%',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    amountToRefund: {
      fontWeight: 700,
      fontSize: '18px',
      color: 'rgba(41, 121, 255, 0.87)',
    },
    cardPaymentProcessingTime: {
      fontWeight: 700,
      fontSize: '12px',
    },
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      maxHeight: '170px',
      overflowY: 'auto',
    },
  }
))
